(function () {
    'use strict';

    angular
        .module('app.surveys')
        .controller('SurveyListController', SurveyListController);

    SurveyListController.$inject = ['common', 'dataservice', 'bootstrap.dialog', 'config', '$http'];
    /* @ngInject */
    function SurveyListController(common, dataservice, bsDialog, config, $http) {
        var vm = this;
        vm.title = 'Surveys';
        vm.displayedItems = [];
        vm.items = [];


        activate();

        function activate() {
            var promises = [common.checkIsAdmin(), getItems()];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }

        function getItems() {
            return dataservice.getItems('api/Surveys').then(function (response) {
                var data = response.data;
                vm.items = data;
                vm.displayedItems = [].concat(vm.items);
                return vm.items;
            }, function (error) { });
        }
        
    }
})();
